import { DataSourceName, DataSourceParameterMap } from "features/data-source/data-source.types";
import { useDataSourceOldApproach } from "features/data-source/useDataSourceOldApproach";
import { useLazyDataSourceOldApproach } from "features/data-source/useLazyDataSourceOldApproach";
import { DataSourceParameter } from "store/services/deprecated/data-source.service";

export const useDataSource = <T = any>(
    dataSource: DataSourceName,
    parameters?: DataSourceParameterMap<any>,
    options?: { skip?: boolean }
) => {
    return useDataSourceOldApproach<T>(dataSource, parameters, options);
};

export const useLazyDataSource = <T = any>(dataSource: DataSourceName) => {
    return useLazyDataSourceOldApproach<T>(dataSource);
};

export const toDataSourceParameters = <T extends Record<string, any>>(parameters?: T): DataSourceParameter[] => {
    if (!parameters) return [];
    let dataSourceParameters = Object.keys(parameters).map((parameter) => ({
        name: parameter,
        value: parameters[parameter] ?? "",
    }));

    dataSourceParameters = dataSourceParameters.toSorted((a, b) => a.name.localeCompare(b.name));

    return dataSourceParameters;
};
